import * as _ from 'lodash';
import * as moment from 'moment';
import { Component } from 'react';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, FollowUpActionCreators, IApplicationState, IAppState, IFollowUpSurveyResponse } from '@nkr/store/index';
import { IBaseResponse, IFollowUpSurvey, IFollowUpSurveyForList, IListItem } from '@nkr/models/index';
import { FollowUpStatus } from '@nkr/enums/index';
import { Alert, Col, DropdownButton, Label, MenuItem, Row } from 'react-bootstrap';
import ReviewStatus from './review-status';
import DonorDetails from './donor-details';
import ProgressComplianceDetails from './progress-compliance-details';
import PreviousDetails from './previous-details';
import Details from './details';
import ReviewDetails from './review-details';
import { getMenuItems } from '../list/action-button-renderer';
import { menuItemList } from '../menu-item-list';
import { toast } from 'react-toastify';
import { downloadFile } from '@nkr/services/download-file';
import { SurveyAction } from '../list/survey-action';
import UploadLabOrders from '../upload-lab-orders';
import MarkIncomplete from '../mark-incomplete';
import MarkOrdersSent from '../mark-orders-sent';
import MarkAppointmentBooked from '../mark-appointment-booked';
import ResendSurveyEmail from '../resend-survey-email';

interface IProps {
    id: number,
    isAdmin: boolean,
    isAdminLogin: boolean,
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getFollowUpSurvey: (id: number) => Promise<IFollowUpSurveyResponse>,
    markReviewed: (id: number, reviewerContactId) => Promise<IBaseResponse>,
    markIncomplete: (id: number) => Promise<IBaseResponse>,
    markOrdersSent: (id: number) => Promise<IBaseResponse>,
    appointmentBooked: (id: number) => Promise<IBaseResponse>,
    uploadLabOrders: (id: number, file: File) => Promise<IBaseResponse>,
    sendSurveyEmail: (id: number) => Promise<IBaseResponse>,
    getSurveyPdf: (id: number) => Promise<any>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    data: IFollowUpSurvey,
    previous: IFollowUpSurvey,
    reviewerContactId: number,
    showUploadLabOrders: boolean,
    showConfirmMarkIncomplete: boolean,
    showConfirmMarkOrdersSent: boolean,
    showConfirmAppointmentBooked: boolean,
    showConfirmResendSurveyEmail: boolean,
    reviewers: IListItem[]
}

class FollowUpSurveyView extends Component<TProps, IState> {
    readonly state: IState = {
        data: null,
        previous: null,
        reviewerContactId: 0,
        showUploadLabOrders: false,
        showConfirmMarkIncomplete: false,
        showConfirmMarkOrdersSent: false,
        showConfirmAppointmentBooked: false,
        showConfirmResendSurveyEmail: false,
        reviewers: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting survey details, one moment please...').then(() => {
            this.props.getFollowUpSurvey(this.props.id).then(response => {
                this.setState({
                    data: response.data.results.current,
                    previous: response.data.results.previous,
                    reviewers: response.data.results.reviewers
                });

                this.props.hideLoading();
            });
        });
    }

    getSurveyPdf = () => {
        this.props.showLoading('Getting financial info, one moment please...').then(() => {
            this.props.getSurveyPdf(this.props.id).then((response: any) => {
                this.props.hideLoading();

                downloadFile(response.data, `survey-details-${this.props.id}.pdf`, 'application/pdf');
            });
        });
    }

    handleActionSelect = (e: any) => {
        let { id, editKey, dashDomain } = this.state.data;
        dashDomain = dashDomain.replace('.org', __HIGH_LEVEL_DASH_DOMAIN__);

        switch (e) {
            case SurveyAction.MarkComplete:
                window.location.href = '/center/' + this.state.data.centerId + '/follow-up/survey/' + this.props.id + '/mark-complete';
                break;

            case SurveyAction.UploadRequisition:
                this.setState({
                    showUploadLabOrders: true
                });

                break;

            case SurveyAction.FollowUpUnsuccessful:
                this.setState({
                    showConfirmMarkIncomplete: true
                });

                break;

            case SurveyAction.RequisionAlreadySent:
                this.setState({
                    showConfirmMarkOrdersSent: true
                });

                break;

            case SurveyAction.MarkAppointmentBooked:
                this.setState({
                    showConfirmAppointmentBooked: true
                });

                break;

            case SurveyAction.ResendSurveyEmail:
                this.setState({
                    showConfirmResendSurveyEmail: true
                });

                break;

            case SurveyAction.PhoneInterviewSurvey:
                window.open(`https://${dashDomain}/follow-up/survey/${id}/${editKey}`, '_blank');

                break;

            case SurveyAction.GetPDF:
                this.getSurveyPdf();
                break;
        }

        if (e == SurveyAction.GetPDF) {
            this.getSurveyPdf();
        }
    }

    handleReviewerChange = (reviewerContactId: number) => {
        this.setState({
            reviewerContactId
        });
    }

    handleMarkReviewed = () => {
        this.props.showLoading('Updating survey, one moment please...').then(() => {
            this.props.markReviewed(this.props.id, this.state.reviewerContactId).then(response => {
                if (response.data.success) {
                    toast.success('Survey updated successfully');

                    let data = _.cloneDeep(this.state.data);
                    data.isReviewed = true;
                    data.reviewedByUserId = this.props.app.user.id;
                    data.reviewedByUserName = this.props.app.user.username;
                    data.reviewedByContactName = this.state.reviewers.find(x => x.id == this.state.reviewerContactId).description;
                    data.reviewedDateTime = moment().format('MM/DD/YYYY');

                    this.setState({
                        data
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handleUploadLabOrders = (file: File) => {
        this.setState({
            showUploadLabOrders: false
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.uploadLabOrders(this.props.id, file).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelUploadLabOrders = () => {
        this.setState({
            showUploadLabOrders: false
        });
    }

    handleConfirmMarkIncomplete = () => {
        this.setState({
            showConfirmMarkIncomplete: false
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.markIncomplete(this.props.id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelMarkIncomplete = () => {
        this.setState({
            showConfirmMarkIncomplete: false
        });
    }

    handleConfirmMarkOrdersSent = () => {
        this.setState({
            showConfirmMarkOrdersSent: false
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.markOrdersSent(this.props.id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelMarkOrdersSent = () => {
        this.setState({
            showConfirmMarkOrdersSent: false
        });
    }

    handleConfirmAppointmentBooked = () => {
        this.setState({
            showConfirmAppointmentBooked: false
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.appointmentBooked(this.props.id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelAppointmentBooked = () => {
        this.setState({
            showConfirmAppointmentBooked: false
        });
    }

    handleConfirmResendSurveyEmail = () => {
        this.setState({
            showConfirmResendSurveyEmail: false
        }, () => {
            this.props.showLoading('Resending survey email, one moment please...').then(() => {
                this.props.sendSurveyEmail(this.props.id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Email successfully sent');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelResendSurveyEmail = () => {
        this.setState({
            showConfirmResendSurveyEmail: false
        });
    }

    renderActionDropdown = () => {
        let menuItems = getMenuItems(this.state.data).filter(action => action != 1).map(item => {
            return menuItemList.find(x => x.action == item);
        });

        return (
            <DropdownButton bsStyle='primary' title='Available Actions' id='survey-actions' onSelect={this.handleActionSelect}>
                {menuItems.map(item => {
                    return (
                        <MenuItem eventKey={item.action}>{item.title}</MenuItem>
                    );
                })}
            </DropdownButton>
        );
    }

    render = () => {
        if (this.state.data == null)
            return null;

        const modalData = { ...this.state.data, complianceDaysLeft: 0 }

        return (
            <>
                <Row>
                    <Col xs={12} md={8} mdOffset={2}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
                            <h1 className='text-left' style={{ margin: 0 }}>View Follow-Up Survey</h1>
                            <div>
                                Current Status: <Label style={{ fontSize: '100%' }}>{this.state.data.status}</Label>
                            </div>
                            <div className="dropdown pull-right">
                                {this.renderActionDropdown()}
                            </div>
                        </div>

                        <br />

                        {this.state.data.isReviewed && (
                            <ReviewStatus data={this.state.data} />
                        )}

                        <DonorDetails data={this.state.data} />

                        <ProgressComplianceDetails data={this.state.data} />

                        {this.state.data.statusId == FollowUpStatus.CompleteDirectToCenter && this.state.data.hasDiabetes != null ?
                            <Alert bsStyle='warning'>Survey was completed at the center</Alert>
                            :
                            <>
                                {this.state.previous != null ?
                                    <PreviousDetails data={this.state.data} previous={this.state.previous} />
                                    :
                                    <Details data={this.state.data} />
                                }
                            </>
                        }

                        {this.state.data.isReviewed == false && (
                            <ReviewDetails
                                reviewerContactId={this.state.reviewerContactId}
                                reviewers={this.state.reviewers}
                                onReviewerChange={this.handleReviewerChange}
                                onMarkReviewed={this.handleMarkReviewed}
                            />
                        )}
                    </Col>
                </Row>

                <UploadLabOrders
                    show={this.state.showUploadLabOrders}
                    data={modalData}
                    onUpload={this.handleUploadLabOrders}
                    onCancel={this.handleCancelUploadLabOrders}
                />

                <MarkIncomplete
                    show={this.state.showConfirmMarkIncomplete}
                    data={modalData}
                    onConfirm={this.handleConfirmMarkIncomplete}
                    onCancel={this.handleCancelMarkIncomplete}
                />

                <MarkOrdersSent
                    show={this.state.showConfirmMarkOrdersSent}
                    data={modalData}
                    onConfirm={this.handleConfirmMarkOrdersSent}
                    onCancel={this.handleCancelMarkOrdersSent}
                />

                <MarkAppointmentBooked
                    show={this.state.showConfirmAppointmentBooked}
                    data={modalData}
                    onConfirm={this.handleConfirmAppointmentBooked}
                    onCancel={this.handleCancelAppointmentBooked}
                />

                <ResendSurveyEmail
                    show={this.state.showConfirmResendSurveyEmail}
                    data={modalData}
                    onConfirm={this.handleConfirmResendSurveyEmail}
                    onCancel={this.handleCancelResendSurveyEmail}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getFollowUpSurvey: (id) => {
            return dispatch(FollowUpActionCreators.getSurvey(id));
        },
        markReviewed: (id, reviewerContactId) => {
            return dispatch(FollowUpActionCreators.markReviewed(id, reviewerContactId));
        },
        markIncomplete: (id) => {
            return dispatch(FollowUpActionCreators.markIncomplete(id));
        },
        markOrdersSent: (id) => {
            return dispatch(FollowUpActionCreators.markOrdersSent(id));
        },
        appointmentBooked: (id) => {
            return dispatch(FollowUpActionCreators.appointmentBooked(id));
        },
        uploadLabOrders: (id, file) => {
            return dispatch(FollowUpActionCreators.uploadLabOrders(id, file));
        },
        sendSurveyEmail: (id) => {
            return dispatch(FollowUpActionCreators.sendSurveyEmail(id));
        },
        getSurveyPdf: (id) => {
            return dispatch(FollowUpActionCreators.getSurveyPdf(id));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FollowUpSurveyView);